import React, { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useHotelAdminStore } from '../store'
import { apiClient } from '../services/apiClient'
import { extractErrorMessage } from '../utils/errorHandler'
import { ROUTES } from '../constants/routes'

export default function AdminLoginPage() {
  const navigate = useNavigate()
  const setAdmin = useHotelAdminStore((state) => state.setAdmin)

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    
    if (!formData.email || !formData.password) {
      setError('Пожалуйста, заполните все поля')
      return
    }

    try {
      setError('')
      setSuccess('')
      setIsLoading(true)
      
      const response = await apiClient.adminLogin(formData.email, formData.password)
      
      if (response.access_token) {
        // Очищаем токен владельца если есть
        localStorage.removeItem('owner_token')
        localStorage.removeItem('owner_username')
        
        setAdmin({
          ...response,
          access_token: response.access_token,
        })
        setSuccess('✅ Вход успешен! Перенаправление...')
        
        setTimeout(() => {
          navigate(ROUTES.ADMIN_DASHBOARD)
        }, 1000)
      } else {
        setError('Ошибка: не получен токен от сервера')
      }
    } catch (err: any) {
      setError(extractErrorMessage(err) || 'Ошибка при входе. Проверьте email и пароль.')
    } finally {
      setIsLoading(false)
    }
  }

  const handleNavigateToRegister = () => {
    navigate('/admin-register-open')
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 p-4">
      <div className="w-full max-w-md">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-indigo-600 mb-2 text-center">HotelCheck</h1>
          <h2 className="text-xl font-semibold text-gray-700 mb-6 text-center">Вход администратора</h2>

          {error && (
            <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
              {error}
            </div>
          )}

          {success && (
            <div className="mb-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded">
              {success}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-700 font-semibold mb-2">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="admin@hotel.com"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600"
                disabled={isLoading}
              />
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-2">Пароль</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="••••••••"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600"
                disabled={isLoading}
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full px-4 py-3 bg-indigo-600 hover:bg-indigo-700 disabled:bg-gray-400 text-white rounded-lg font-semibold transition"
            >
              {isLoading ? 'Загрузка...' : 'Войти'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-gray-600">
              Нет аккаунта?{' '}
              <button
                onClick={handleNavigateToRegister}
                className="text-indigo-600 hover:text-indigo-700 font-semibold"
              >
                Создать аккаунт
              </button>
            </p>
          </div>

          <div className="mt-6 pt-6 border-t border-gray-200">
            <button
              onClick={() => navigate('/')}
              className="w-full px-4 py-2 text-gray-600 hover:text-gray-800 font-semibold"
            >
              ← Вернуться на главную
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
